import React from 'react'

const DogContext = React.createContext({})

export default DogContext
